import Component from './components/UsersRegistration';

import { PATH } from './constants';

export { PATH };
export default Component;
